<template>
    <div>
        <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Etablissement Origine</label>
                        <select name="orgapartenaire_id" v-model="orgapartenaire" class="form-control kt_select2">
                            <option v-for="partenaire in partenaires" :key="`partanaire_${partenaire.id}`" :value="partenaire.id">{{ partenaire.nom }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Vacataire</label>
                        <select id="vacataire" name="vacataire_id" v-model="vacataire" class="form-control kt_select2" data-live-search="true">
                            <option v-for="vacataire in vacataires" :key="`vacataire_${vacataire.agresso}`" :value="vacataire.id">{{ vacataire.nom +' '+ vacataire.prenom }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Promotion</label>
                        <select name="promotion" v-model="promotion" class="form-control kt_select2">
                            <option v-for="promotion in promotions" :key="promotion" :value="promotion">{{ promotion }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Filière</label>
                        <select name="filiere" v-model="filiere" class="form-control kt_select2">
                            <option v-for="filiere in filieres" :key="filiere.id" :value="filiere.code">{{ filiere.libelle+" "+filiere.code }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Elements de module(s)</label>
                        <input type="text" v-model="elements_modules" name="elements_modules" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Module(s) correspendant(s)</label>
                        <input type="text" v-model="modules" name="modules" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Periode debut</label>
                        <input type="date" v-model="periode_debut" name="periode_debut" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="">Periode fin</label>
                        <input type="date" v-model="periode_fin" name="periode_fin" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class="row">
                        <div class="col-sm-4">
                            <label>Paiement</label>
                        </div>
                        <div class="col-sm-8 radio-list">
                            <label class="radio radio-success">
                                <input type="radio" v-model="paiement" name="paiement" value="vacataire"/>
                                <span></span>
                                Vacataire
                            </label>
                            <label class="radio radio-success">
                                <input type="radio" v-model="paiement" name="paiement" value="partenaire"/>
                                <span></span>
                                Partenaire
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="paiement == 'vacataire'" class="col-12 col-md-4">
                    <div class="row">
                        <div class="col-sm-4">
                            <label>Type du paiement</label>
                        </div>
                        <div class="col-sm-8 radio-list">
                                <label class="radio radio-success">
                                    <input v-model="mode_paiement" type="radio" name="mode_paiement" value="espece">
                                    <span></span>
                                    Espèce
                                </label>
                                <label class="radio radio-success">
                                    <input v-model="mode_paiement" type="radio" name="mode_paiement" value="virement">
                                    <span></span>
                                    Virement
                                </label>
                        </div>
                    </div>
                </div>
                <div v-if="mode_paiement == 'virement'" class="col-12 col-md-4">
                    <div class="row">
                        <div class="col-sm-4">
                            <label>Devise</label>
                        </div>
                        <div class="col-sm-8 radio-list">
                                <label class="radio radio-success">
                                    <input class="form-check-input" v-model="devise" type="radio" name="devise" value="MAD">
                                    <span></span>
                                    Dirham
                                </label>
                                <label class="radio radio-success">
                                    <input class="form-check-input" v-model="devise" type="radio" name="devise" value="EUR">
                                    <span></span>
                                    Euro
                                </label>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    props: {
        partenaires: Array,
        api_token: String,
        filieres: Array,
        promotions: Array,
    },
    data() {
        return {
            filieres: null,
            promotion: null,
            orgapartenaire: null,
            vacataire: null,
            niveau: null,
            paiement: null,
            devise: null,
            filiere: null,
            periode_debut: null,
            periode_fin: null,
            mode_paiement: null,
            vacataires: [],
            modules: null,
            elements_modules: null,
            config: {
                headers: {
                    'Authorization': `Bearer ${this.api_token}`
                }
            }
        }
    },
    watch: {
        orgapartenaire: function(val) {
            axios.get(`/api/vacataire/partenariat/${this.orgapartenaire}`, this.config)
            .then(res => {
                this.vacataires = res.data;
            }).finally(() => {
                $("#vacataire").select2().trigger('refresh');
            });
        },
        promotion: function (val) {
            axios.get(`/api/filieres/${this.promotion}`)
            .then(res => {
                this.filieres = res.data;
            }).finally(() => {
                $('.kt_select2').select2().trigger('refresh');
            });
        }
    },
    created() {
        axios.get('/api/filieres')
        .then(res => {
            this.filieres = res.data;
        }).finally(() => {
            $('.kt_select2').select2().trigger('refresh');
        });
    }
}
</script>

<style>

</style>